import { Result, Report, ReportItem } from "../models/interfaces";
import { BaseService } from "./BaseService";

export class ReportService extends BaseService {
  async getReports(): Promise<Result<Report[]>> {
    return this.get("reports");
  }

  async getReportItems(reportId: number): Promise<Result<ReportItem[]>> {
    return this.get(`reports/${reportId}/items`);
  }

  async getReportItem(reportItemId: number): Promise<Result<ReportItem>> {
    return this.get(`reports/items/${reportItemId}`);
  }

  async deleteReport(id: number): Promise<Result<boolean>> {
    return this.delete(`reports/${id}`);
  }

  async createOrUpdateReport(
    params: {
      name: string;
      columns: number;
    },
    id?: number
  ): Promise<Result<Report | boolean>> {
    if (id) {
      return this.put(`reports/${id}`, params);
    } else {
      return this.post(`reports`, params);
    }
  }

  async createOrUpdateReportItem(
    params: {
      name: string;
      reportId: number;
      column: number;
      parentReportItemId?: number;
      reportItemType: number;
      reportItemValue: number;
    },
    id?: number
  ): Promise<Result<ReportItem | boolean>> {
    if (id) {
      return this.put(`api/report-item/${id}`, params);
    } else {
      return this.post(`api/report-item`, params);
    }
  }

  async deleteReportItem(id: number): Promise<Result<boolean>> {
    return this.delete(`api/report-item/${id}`);
  }
}

export default new ReportService();

export interface IPeriodicReportParams {
  startDate?: Date;
  endDate?: Date;
}

export interface ITransactionReportParams extends IPeriodicReportParams {
  accountId?: number;
  accountTypeIds?: number[];
}

export class DepositReportService extends BaseService {
  async getDepositSummary(params: {
    startDate: Date;
    endDate: Date;
  }): Promise<Result<any>> {
    throw new Error("Not Implemented");
  }
}

export class WithdrawalReportService extends BaseService {
  async getWithdrawalSummary(
    params: ITransactionReportParams
  ): Promise<Result<any>> {
    throw new Error("Not implemented");
  }
}
